import { createClient } from '@supabase/supabase-js';

// Publishable key: safe to expose on the client (data is protected by RLS).
const supabaseUrl =
  import.meta.env.VITE_SUPABASE_URL || 'https://ltzdxpumfbcygxyznypt.supabase.co';
const supabaseKey =
  import.meta.env.VITE_SUPABASE_KEY || 'sb_publishable_GDmQFVoDYy7QXZe3CE3uSQ_eLuaIiV7';

export const supabase = createClient(supabaseUrl, supabaseKey);

// ===== Auth =====
export const auth = {
  signUp: (email, password, fullName) =>
    supabase.auth.signUp({ email, password, options: { data: { full_name: fullName } } }),
  signIn: (email, password) => supabase.auth.signInWithPassword({ email, password }),
  signOut: () => supabase.auth.signOut(),
  getSession: () => supabase.auth.getSession(),
  onChange: (cb) => supabase.auth.onAuthStateChange(cb),
  getRole: async () => {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.user) return { session: null, role: null };
    const { data } = await supabase
      .from('user_profiles')
      .select('role, full_name')
      .eq('user_id', session.user.id)
      .maybeSingle();
    return { session, role: data?.role ?? 'customer', fullName: data?.full_name };
  },
};

// ===== Generic CRUD helpers (admin modules) =====
export const db = {
  list: (table, { orderBy = 'created_at', ascending = false, match } = {}) => {
    let q = supabase.from(table).select('*');
    if (match) Object.entries(match).forEach(([k, v]) => { q = q.eq(k, v); });
    return q.order(orderBy, { ascending });
  },
  insert: (table, row) => supabase.from(table).insert(row).select(),
  update: (table, id, patch, idCol = 'id') =>
    supabase.from(table).update(patch).eq(idCol, id).select(),
  remove: (table, id, idCol = 'id') => supabase.from(table).delete().eq(idCol, id),
  upsert: (table, row, onConflict) => supabase.from(table).upsert(row, { onConflict }).select(),
};

// ===== Storefront queries =====
export const storefront = {
  products: () =>
    supabase.from('products').select('*').eq('active', true).order('created_at', { ascending: false }),
  combos: () =>
    supabase
      .from('combos')
      .select('*, combo_items(quantity, products(id, name, name_en))')
      .eq('active', true)
      .order('created_at', { ascending: true }),
  promotions: () =>
    supabase.from('promotions').select('*').eq('active', true).order('created_at', { ascending: true }),
  offerTiers: () =>
    supabase.from('offer_tiers').select('*').eq('active', true).order('min_subtotal', { ascending: true }),
  content: () => supabase.from('site_content').select('*'),
  createOrder: (order) => supabase.from('orders').insert(order).select().single(),
};
